import { createStyles } from 'antd-style';

import { ThemeColors } from '../../theme';

export const useDynamicTableStyles = createStyles(({ token }) => ({
  dynamicTableContainer: {
    width: '100%',
    flex: 1,
    display: 'flex',
    flexDirection: 'column',

    '.ant-spin-nested-loading, .ant-spin-container': {
      flex: 1,
      display: 'flex',
      flexDirection: 'column',
    },

    '.ant-table-wrapper': {
      flex: 1,
      display: 'flex',
      flexDirection: 'column',

      '.ant-table': {
        boxShadow: `3px 3px 15px 0 ${ThemeColors.COLOR_GREY_BLUISH3}`,
        overflow: 'auto',

        '.ant-table-container': {
          '.ant-table-body, .ant-table-content': {
            scrollbarWidth: 'none',
            scrollbarColor: '#eaeaea transparent',
            scrollbarGutter: 'stable',

            '&::-webkit-scrollbar': {
              height: 8,
              width: 8,
            },

            '&::-webkit-scrollbar-track': {
              background: 'transparent',
            },

            '&::-webkit-scrollbar-thumb': {
              backgroundColor: '#eaeaea',
              borderRadius: 4,
            },
          },

          '.ant-table-header table, .ant-table-body table': {
            width: '100% !important',
          },
        },

        '.ant-table-thead': {
          backgroundColor: `${ThemeColors.COLOR_GREY_BLUISH} !important`,

          '> tr': {
            backgroundColor: `${ThemeColors.COLOR_GREY_BLUISH} !important`,

            '> th': {
              height: 40,
              padding: '9px 10px',
              backgroundColor: `${ThemeColors.COLOR_GREY_BLUISH} !important`,
              color: `${ThemeColors.COLOR_WHITE} !important`,
              fontSize: `${token.fontSize}px !important`,
              fontWeight: '700 !important',
              border: 'none !important',
              borderBottom: 'none !important',
              textAlign: 'left',

              '&::before': {
                display: 'none',
              },

              '&:first-child': {
                borderRadius: '5px 0 0 0',
              },

              '&:last-child:not(.ant-table-cell-scrollbar)': {
                borderRadius: '0 5px 0 0',
              },
            },
          },
        },

        '.ant-table-tbody': {
          backgroundColor: ThemeColors.COLOR_WHITE3,

          '> tr': {
            '&:hover': {
              backgroundColor: ThemeColors.COLOR_WHITE1_5,
            },

            '> td': {
              height: 40,
              padding: '8px 10px',
              borderBottom: `1px solid ${ThemeColors.COLOR_GREY_BLUISH8}`,
              verticalAlign: 'top',
              borderRight: 'none',

              '.InlineLink': {
                display: 'inline',
              },

              '.clickable-cell': {
                color: '#0773e9',
                fontSize: token.fontSize,
                fontWeight: 500,
                textDecoration: 'underline',
                cursor: 'pointer',
              },

              '.font-weight-medium': {
                fontWeight: 500,
              },
            },

            '&:nth-child(even) > td': {
              borderBottom: `1px solid ${ThemeColors.COLOR_WHITE}`,
            },

            '&:last-child > td': {
              borderBottom: 'none',
            },
          },
        },
      },

      '.ant-pagination': {
        textAlign: 'center',
        margin: 0,
        marginTop: 'auto',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        paddingTop: 11,

        '.ant-pagination-prev': {
          marginRight: 0,
        },

        '.ant-pagination-prev, .ant-pagination-next': {
          color: ThemeColors.COLOR_RED,
          height: 20,
          lineHeight: '20px',

          '> span': {
            fontSize: 20,
          },
        },

        '.ant-pagination-simple-pager': {
          fontSize: 0,
          marginRight: 0,
          display: 'inline-flex',
          alignItems: 'center',

          '> input': {
            fontSize: 12,
            fontWeight: 500,
            color: ThemeColors.COLOR_RED,
            marginRight: 5,
            borderRadius: 4,
            border: `0.5px solid ${ThemeColors.COLOR_GREY6}`,
            width: 30,
            height: 20,
          },

          '> span': {
            display: 'none',
          },

          '&::before, &::after': {
            fontSize: 12,
            fontWeight: 500,
            color: ThemeColors.COLOR_GREY_BLUISH,
            textTransform: 'uppercase',
            lineHeight: '20px',
          },

          '&::before': {
            content: 'var(--page-label)',
            marginRight: 5,
          },

          '&::after': {
            content: 'var(--out-of-label)',
          },
        },
      },
    },
  },
}));
